import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Box } from '../../atoms/Box';
import { TextField } from '../../atoms/TextField/TextField';
import { Typography } from '../../atoms/Typography';

import { COLORS } from '../../../configs/colors';

export const GridWrapper = styled(Box)`
  width: 100%;
  border: 2px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  box-sizing: border-box;
  margin-bottom: 10px;
`;

export const StructureChildLocationAddGrid = styled(Grid)`
  margin-top: 4px;
`;

export const StyledTypography = styled(Typography)`
  margin-bottom: 10px;
`;

export const StyledTextField = styled(TextField)`
  margin-top: 10px;
  margin-bottom: 10px;
  max-height: 50vh;
`;